import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Header, Segment, Table } from 'semantic-ui-react'
import CropItem from './CropItem'
import InfoPopup from '~/components/InfoPopup'

interface Props {
  herdIndex: number
}

const HerdGroupCrops: React.FC<Props> = ({ herdIndex }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `herdGroups[${herdIndex}].crops`,
    keyName: 'key'
  })

  return (
    <>
      <Header attached='top' block>
        {t('Crops')}
      </Header>
      <Segment attached>
        <Table celled>
          <colgroup>
            <col style={{ width: '20%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '15%' }} />
          </colgroup>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('Crop')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Feed component')}</Table.HeaderCell>
              <Table.HeaderCell>
                <div style={{ display: 'flex', gap: 5 }}>
                  <div>{t('DM / animal / day')}</div>
                  <InfoPopup
                    content={t('Enter dry matter (DM) intake per animal per day averaged throughout the whole year.')}
                    styleIcon={{ fontSize: '1.2em', color: 'white' }}
                />
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell>{t('FW / animal / day')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {fields.map((field, cropIndex) => (
              <CropItem
                id={field.key}
                key={field.key}
                index={cropIndex}
                removeCrop={remove}
                herdIndex={herdIndex}
             />
            ))}
          </Table.Body>
        </Table>
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: '1em' }}>
          <Button
            type='button'
            size='small'
            icon='plus'
            style={{ color: 'white' }}
            content={t('Add Crop')}
            onClick={() => append({
              id: null,
              dryMatterValue: null,
              freshWeightValue: null
            })}
          />
        </div>
      </Segment>
    </>
  )
}

export default HerdGroupCrops
